module.exports = {
  "country": "MT",
  "artist": "Ira Losco",
  "song": "7th Wonder ",
  "year": "2002",
  "place": "2",
  "spotify": "6rF1ZmDKZKhEv49l2OrYCl"
};